// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExploreRoot.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
// 
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { PureComponent } from 'react';
import Icon from 'share/components/controls/Izenda.Icon';
import ReportViewerContent from '../../Reports/ReportViewer/Izenda.ReportViewerContent';
import ReportDesignerStore from 'logic/Izenda.ReportDesignerStore';
import ReportDesignerFieldsStore from 'logic/Izenda.ReportDesignerFieldsStore';
import ReportDesignerDataSourceStore from 'logic/Izenda.ReportDesignerDataSourceStore';
import ReportsStore from 'logic/Izenda.ReportsStore';
import DropDown from 'share/components/controls/Izenda.DropDown';
import reportDesignerConstants from 'logic/data/Izenda.ReportDesignerConstants';
import FilterWrap from 'share/components/controls/Filter';
import RecordsCount from 'share/components/controls/DataGrid/helpers/Izenda.RecordCount';
import QueryResult from 'share/components/controls/QueryResult';
class NLQQuery extends PureComponent {
  constructor(props) {
    super(props);
    this.masterStore = new ReportDesignerStore(
      true,
      '',
      null,
      null,
      false,
      true,
      this.props.store.getResultReportDefinition
    );

    this.masterStore.model.markTotalRecordQueryEnable();
    this.reportDesignerFieldsStore = new ReportDesignerFieldsStore(
      this.masterStore,
      true,
      0,
      this.props.store
    );
    this.reportDesignerDataSource = new ReportDesignerDataSourceStore(this.masterStore);
    this.reportStore = new ReportsStore();
    this.GetAvailableQuerySourceFields();
  }

  componentDidMount(){
    this.reportDesignerFieldsStore.setNeedToExploreStoreReportInfoUpdate(true);
   
  }

  GetAvailableQuerySourceFields = () => {
    const {store} = this.props;
    store.getAvailableQuerySourceFields(store.getResultReportDefinition,this.reportDesignerFieldsStore);
  }
  /**
   * Set ref to content
   * @param {Object} node
   */
  setViewerContentRef = (node) => {
    this.viewerContentNode = node;
    this.updateViewerContentHeight();
  };

  updateViewerContentHeight = () => {
    if (this.viewerNode) {
      const { top, height } = this.viewerNode.getBoundingClientRect();
      const newFooterHeight = window.innerHeight - top - height;
      newFooterHeight !== this.footerHeight && (this.footerHeight = newFooterHeight);
    }

    if (this.viewerContentNode) {
      const { top } = this.viewerContentNode.getBoundingClientRect();
      const newViewerContentHeight = window.innerHeight - top - this.footerHeight;
      newViewerContentHeight !== this.viewerContentHeight && (this.viewerContentHeight = newViewerContentHeight);
    }
  };
  /**
   * delete filter record
   * @param {action} a
   */
  removeNLQFilterItem = itemdata => {
    const {
      reportDesignerFieldsStore,
      props: { store, validation }
    } = this;

    const reportFilters = reportDesignerFieldsStore.reportFilters || {};
    reportDesignerFieldsStore.updateReportDesignerCascadingFilter(itemdata);
    reportFilters.removeFilter && reportFilters.removeFilter(itemdata);
    const logic = store.getFilterLogic(reportFilters.logic,itemdata.position);
    reportFilters.setLogic(logic);
    reportFilters.populateFilterList(reportFilters.filterFields);
    reportDesignerFieldsStore.reportFilters.setConfigModeToField(null);
    validation.validate();
    reportDesignerFieldsStore.updateReportsParts(false,null,true);
  };


  /**
   * Change preview record
   * @param {Event} e
   */
  changePreviewRecord = e => {
    const {
      masterStore,
      reportDesignerFieldsStore    } = this;
    masterStore.model.updatePreviewRecord(e.value);
    this.reportDesignerFieldsStore.reportFilters.resetUpdateResult();
    reportDesignerFieldsStore.updateReportsParts(false,null,true);
  };

  render() {
    const { removeNLQFilterItem } = this;
    const { model } = this.masterStore;
    const { props, props:{localization, store},reportDesignerFieldsStore,reportStore } = this;
    
    return (
      <div className='report-viewer-content'>
        <div className='query-search-wrapper clearfix'>
          <div className='query-search-box'>
            <Icon className='icon-search icon-abs-search' />
            <span>{props.searchString}</span>
            <Icon
              className='icon-cancel'
              onClick={() => {
                props.setActive(1);
              }}
            />
          </div>
        </div>
        <div className='explore-filter-wrapper clearfix'>
          <div className='explore-filter-wrapper-left'>
            {store.model.noOfTotalRecords > 0 && (
              <RecordsCount
                totalRecords={store.model.noOfTotalRecords}
                columns={store.model.noOfColumns}
              />
            )}
             {reportDesignerFieldsStore.reportFilters.filterFields.length > 0 ? (
                <div className='explore-report-header clearfix'>
                  <div className='filters-wrap'>
                    <label className='filter-label'> Filters : </label>
                    <ul>
                      {reportDesignerFieldsStore.reportFilters.filterFields.map(field => {
                        return (
                          <FilterWrap key={field.uniqueId} itemData={field} removeNLQFilterItem={removeNLQFilterItem} />
                        );
                      })}
                    </ul>
                  </div>
                </div>
              ) : null}
            </div>
          <div className='explore-filter-wrapper-right explore-report-header clearfix'>
              {/* <h1></h1> */}
              <div className='wrapper-preview'>
                <div className='u_table u_paddingInner u-bgWhite preview-records default'>
                  <span className='u_tableCell control-label'>
                    {localization.getText('REPORTDESIGNER_LABEL_PREVIEW_RECORDS')}
                  </span>
                  <div className='u_tableCell u_fullWidth'>
                    <DropDown
                      options={reportDesignerConstants.PREVIEW_RECORD}
                      value={model.previewRecord}
                      labelField='label'
                      valueField='value'
                      onChange={this.changePreviewRecord}
                    />
                  </div>
                </div>
              </div>

              {/* <button className="filter-btn"><Icon className="icon-edit filter-icon" /> General Filters</button> */}
            </div>
        </div>
        <div className='explore-report-wrapper'>
          <ReportViewerContent
            setViewerContentRef={this.setViewerContentRef}
            className='content-container'
            bottom={400}
            {...this.props}
            store={reportDesignerFieldsStore}
            reportViewerStore={reportStore}
            viewerContentHeight={330}
          />
          <QueryResult
            localization={localization}
            reportDesignerFieldsStore={reportDesignerFieldsStore}
            exploreStore ={store}
            reportBody = {reportDesignerFieldsStore.reportBody}
          />
        </div>
      </div>
    );
  }
}

export default NLQQuery;



// WEBPACK FOOTER //
// ./ui/modules/Explore/NLQQuery/Izenda.NLQQuery.jsx